export interface IMeterReadingPhotoEvidences {
  freshdeskTicketId: string
  meterReadingPhotoEvidences: MeterReadingPhotoEvidence[]
}

export interface MeterReadingPhotoEvidence {
  submissionDate: string
  standardRead: null | number
  dayRead: null | number
  nightRead: null | number
  errorCode: string
  imageIdentifier: string
  fuel: string
  meterPointIdentifier: string
  requestReason: string
  createdAt: string
}

export const enum PhotoSource {
  Customer = "Customer",
  SiteVisit = "Site Visit",
}

export interface IMeterReadingPhotoItem {
  [key: string]: unknown
  date: string
  sortDate: string
  fuel: string
  meterPoint: string
  failedRead: number[] | string
  errorCode: string
  requestReason: string
  freshdesk: string
  source: PhotoSource
  installer?: string
  accountNumber?: string
  // Label shown when the row belongs to another account at the same site,
  // e.g. 'Newer account' or 'Previous account'. Absent for the viewed account.
  otherAccountLabel?: string
  rowColor?: string
  viewImage: viewImage[]
}

export type viewImage = {
  displayName: string
  path: string
  directUrl?: string
}
